import { assertNever } from 'lib/utils/types';

export enum ReportIssueType {
  Classification = 'classification',
  DatabaseMatching = 'database_matching',
  Extraction = 'extraction',
  Fraud = 'fraud',
  Other = 'other',
}

export enum ReportGenericFraudType {
  Other = 'other',
}

export enum ReportGovIDFraudType {
  ElectronicReplica = 'electronic_replica',
  Fake = 'fake',
}

export enum ReportSelfieFraudType {
  IDSelfieMismatch = 'id_selfie_comparison',
  DigitalSpoof = 'digital_spoof',
  Mask = 'mask',
}

export enum ReportIssueResponseType {
  NotRequired = 'not_required',
  WithinAWeek = 'within_a_week',
  Urgent = 'urgent',
}

export const reportIssueSuccessMessage = (issueResponseType: ReportIssueResponseType) => {
  switch (issueResponseType) {
    case ReportIssueResponseType.NotRequired:
      return 'Thank you for reporting this issue! We review and track these issues over time to inform product improvements.';
    case ReportIssueResponseType.WithinAWeek:
      return 'Thank you for reporting this issue! A member of our team will review and respond within a week.';
    case ReportIssueResponseType.Urgent:
      return 'Thank you for reporting this issue! A member of our team will review and respond as soon as possible.';
    default:
      assertNever(issueResponseType);
  }
};
